import {Injectable, ElementRef} from '@angular/core';
import { BrandProvider } from '@brand/services/brand-provider';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  private brandName: string;
  private readonly isPrintingSubject = new Subject<boolean>();
  isPrinting$ = this.isPrintingSubject.asObservable();

  constructor(
    private brandProvider: BrandProvider){
      this.brandProvider.getCustomerBrandName().subscribe(x => this.brandName = x);
  }

  public print(printableComponent: ElementRef,
    displayHeader: boolean,
    headCss: string[] = []): void {

    this.isPrintingSubject.next(true);

    const headerImgSrc = `/assets/brand/brands/${this.brandName}/headerLogo.png`;

    const html = printableComponent.nativeElement.outerHTML;
    const printContents = html; // may need to modify -> this.getHtmlContents();
    const popupWin = window.open("", "printframe", "top=0,left=0,height=auto,width=auto");
    const headerImageContent = displayHeader ? `<div id='header' style="text-align:right; height: 120px; width:100%"><img style="max-width:300; max-height:65; width: auto; height: auto;" src='${headerImgSrc}' onerror="this.onerror=null;this.src='/assets/brand/brands/mojo/headerLogo.png'" ></div>` : ''
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head></head>
        <body>
          ${headerImageContent}
          ${printContents}
          <script defer>
            function triggerPrint(event) {
              window.removeEventListener('load', triggerPrint, false);
              setTimeout(function() {
                window.print();
                setTimeout(function() { window.close(); }, 0);
              }, 0);
            }
            window.addEventListener('load', triggerPrint, false);
          </script>
        </body>
      </html>`);

    this.setHeadCss(popupWin.document, headCss);

    popupWin.document.close();
    this.isPrintingSubject.next(false);
  }

  private setHeadCss(
      doc: Document,
      headCss: string[] = []): void {
    headCss.forEach(css => {
      const styleEl = doc.createElement("style");
      styleEl.appendChild(doc.createTextNode(css));
      doc.head.appendChild(styleEl);
    });
  }

}
